/**
 * @desc 获取api订阅列表
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(shopCode: string, options?: any) {
  return updateResponse(
    http(URL + `/walmart/WalmartNotifications/getSubscriptions/${shopCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
